import React, { memo, useEffect } from 'react'
import { FeedbackMessage } from 'components/marketplace/FeedbackMessage'
import PropTypes from 'prop-types'
import { Spinner } from 'transfix-ui/components/Spinner'
import { driverLocationsColumnOrder } from 'apps/user/constants/driverLocations'
import { LegacyTableHeader as TableHeader } from 'components/atoms'
import { DriverLocationsRow } from './DriverLocationsRow'

export const DriverLocations = memo(
  ({
    driverLocations,
    error,
    fetching,
    getDriverLocations,
    getParentDriverLocations,
    parentUserId,
    userUuid,
  }) => {
    useEffect(() => {
      if (userUuid) getDriverLocations(userUuid, 20)
      if (parentUserId) getParentDriverLocations(parentUserId, 20)
    }, [userUuid])

    const ready = !fetching && !error
    return (
      <div className='row' data-test='driver-locations-tab-content'>
        {error && <FeedbackMessage message={error} type='error' />}
        <TableHeader columns={driverLocationsColumnOrder} />
        {fetching && <Spinner position='relative' />}
        {ready && (
          <div className='pv1'>
            {!driverLocations.length ? (
              <p className='tc'>No driver locations available.</p>
            ) : (
              driverLocations.map(driverLocation => (
                <DriverLocationsRow
                  key={driverLocation.phoneTimestamp}
                  driverLocations={driverLocation}
                />
              ))
            )}
          </div>
        )}
      </div>
    )
  }
)

DriverLocations.propTypes = {
  userUuid: PropTypes.string,
  getDriverLocations: PropTypes.func,
  getParentDriverLocations: PropTypes.func,
  driverLocations: PropTypes.arrayOf(PropTypes.shape({})),
  fetching: PropTypes.bool,
  error: PropTypes.string,
}

DriverLocations.defaultProps = {
  userUuid: '',
  getDriverLocations: () => {},
  getParentDriverLocations: () => {},
  driverLocations: [],
  fetching: false,
  error: null,
}
